export default "__VITE_ASSET__57db88d9__"